import { Grid } from '@mui/material'
import { useSelector } from 'react-redux'
import moment from 'moment'

import { FC } from 'react'

import ResultsCard from '../../resultsCard'
import { RootState } from 'dataStore/state'
import { colors } from '../../../ThemeStyle'
import formatPrice from 'handlers/priceFormat'
import { IOrder } from 'dto/orders.dto'

interface IProp {
	orders: IOrder[] | null
}

const TotalBlock: FC<IProp> = ({orders}) => {
	const { filter, statistic } = useSelector((state: RootState) => state.orders)

	if(!orders) return <></>

  const totalOrders = statistic?.count

  // Подсчет заказов за сегодня и вчера
  const today = moment().startOf('day')
  const yesterday = moment().subtract(1, 'day').startOf('day')
  const tomorrow = moment().add(1, 'day').startOf('day')

  const ordersToday = orders?.filter(order => {
    if (!order?.create_at) return false
    const orderDate = moment(order.create_at)
    return orderDate.isSameOrAfter(today) && orderDate.isBefore(tomorrow)
  }) || []

  const ordersYesterday = orders?.filter(order => {
    if (!order?.create_at) return false
    const orderDate = moment(order.create_at)
    return orderDate.isSameOrAfter(yesterday) && orderDate.isBefore(today)
  }) || []

  const ordersTodayYesterday = `${ordersToday.length}/${ordersYesterday.length}`

	const price = /* filter.status ? orders
		?.filter(order=> order?.status_obj?.description !== 'Отменён')
		?.reduce((acc, num: any) => acc + Number(num.total_price), 0) : */ Number(statistic?.total_price)


  return (
    <Grid container spacing={3} sx={{ mb: '25px' }}>
      <Grid item xs={12} sm={6} md={4}>
        <ResultsCard
          total={totalOrders}
          text={'Всего заказов'}
          color={colors.info}
        />
      </Grid>
      <Grid item xs={12} sm={6} md={4}>
        <ResultsCard
          total={ordersTodayYesterday}
          text={'Заказов за сегодня/вчера'}
          color={colors.warning}
        />
      </Grid>
      <Grid item xs={12} sm={6} md={4}>
        <ResultsCard total={formatPrice(price)} text={'Сумма'} color={colors.success} />
      </Grid>
    </Grid>
  )
}

export default TotalBlock
